module.exports = "/_next/static/images/e7f241da2dd62864ded5fe1cf15feaa5-mockup-transfer@1.5x.jpg";